export const LEARNING_OBJECT_TYPE = 'LearningObject';
export const INVALID_TYPE = '<INVALID TYPE>';
